import React from 'react';
import Icon from '../AppIcon';


const Modal = ({ 
  isOpen, 
  onClose, 
  title, 
  description, 
  type = 'info',
  icon,
  children,
  actions,
  showCloseButton = true,
  closeOnOverlayClick = true
}) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (closeOnOverlayClick && e?.target === e?.currentTarget) {
      onClose();
    }
  };

  const getTypeStyles = () => {
    switch (type) {
      case 'success':
        return {
          iconBg: 'bg-gradient-to-br from-green-500/20 to-green-600/10',
          iconColor: 'text-green-500',
          defaultIcon: 'CheckCircle'
        };
      case 'error':
        return {
          iconBg: 'bg-gradient-to-br from-red-500/20 to-red-600/10',
          iconColor: 'text-red-500',
          defaultIcon: 'XCircle'
        };
      case 'warning':
        return {
          iconBg: 'bg-gradient-to-br from-amber-500/20 to-amber-600/10',
          iconColor: 'text-amber-500',
          defaultIcon: 'AlertTriangle'
        };
      case 'info':
      default:
        return {
          iconBg: 'bg-gradient-to-br from-blue-500/20 to-blue-600/10',
          iconColor: 'text-blue-500',
          defaultIcon: 'Info'
        };
    }
  };

  const typeStyles = getTypeStyles();
  const displayIcon = icon || typeStyles?.defaultIcon;

  return (
    <div 
      className="fixed inset-0 bg-background/80 backdrop-blur-md z-50 flex items-center justify-center p-3 sm:p-4 animate-in fade-in duration-200"
      onClick={handleOverlayClick}
    >
      <div className="elevated-card rounded-3xl shadow-glass-lg max-w-md w-full animate-in fade-in zoom-in duration-300 max-h-[90vh] overflow-y-auto backdrop-blur-xl border border-border/50">
        <div className="p-6 sm:p-8 space-y-4 sm:space-y-6">
          {/* Header */}
          <div className="flex items-start gap-3 sm:gap-4">
            <div className={`flex-shrink-0 w-12 h-12 sm:w-14 sm:h-14 rounded-2xl ${typeStyles?.iconBg} flex items-center justify-center shadow-glass`}>
              <Icon name={displayIcon} size={24} className={`${typeStyles?.iconColor}`} />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-lg sm:text-xl font-bold text-foreground mb-2 font-heading">
                {title}
              </h3>
              {description && (
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {description}
                </p>
              )}
            </div>
            {showCloseButton && (
              <button
                onClick={onClose}
                className="glass-subtle hover:glass-strong rounded-lg p-2 transition-all duration-200 flex-shrink-0 touch-manipulation"
                aria-label="Close"
              >
                <Icon name="X" size={20} />
              </button>
            )}
          </div>

          {/* Content */}
          {children && (
            <div className="text-sm text-foreground leading-relaxed">
              {children}
            </div>
          )}

          {/* Actions */}
          {actions && (
            <div className="flex flex-col sm:flex-row gap-3 pt-2">
              {actions}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Modal;